
export class FiveQuestions {

    protected readonly quiz: HTMLElement;
    protected questionsContainer: HTMLElement;
    protected questions: NodeListOf<HTMLElement>;

    protected resultsContainer: HTMLElement;

    protected startButton: HTMLElement;
    protected nextButton: HTMLElement;
    protected restartButton: HTMLElement;

    protected circleBar: HTMLElement;
    protected timeText: HTMLElement;

    protected overlay: HTMLElement;

    protected currentIndex: number = 0;
    protected running: boolean = false;

    protected currentTime = 30;

    constructor(quiz: HTMLElement) {
        this.quiz = quiz;

        this.resolveElements();
        this.addListeners()
        this.initAnimation();
    }

    protected resolveElements() {
        this.questionsContainer = this.quiz.querySelector<HTMLElement>("[data-five-questions-questions]")
        this.questions = this.questionsContainer.querySelectorAll<HTMLElement>("[data-five-questions-question-item]");

        this.resultsContainer = this.quiz.querySelector<HTMLElement>("[data-five-questions-results]")

        this.startButton = this.quiz.querySelector<HTMLElement>("[data-five-questions-start-button]");
        this.nextButton = this.quiz.querySelector<HTMLElement>("[data-five-questions-next-button]");
        this.restartButton = this.quiz.querySelector<HTMLElement>("[data-five-questions-new-button]");

        this.circleBar = this.quiz.querySelector<HTMLElement>("[data-five-questions-progress-circle]");
        this.timeText = this.quiz.querySelector<HTMLElement>("[data-five-questions-progress-time]");

        this.overlay = this.quiz.querySelector<HTMLElement>("[data-five-questions-overlay]");
    }

    protected addListeners() {
        this.startButton.addEventListener("click", this.start.bind(this));
        this.nextButton.addEventListener("click", this.next.bind(this));
        this.restartButton.addEventListener("click", this.restart.bind(this));
    }

    protected start() {
        this.running = true;
        this.currentIndex = 0;
        this.currentTime = 30;

        this.questionsContainer.classList.remove("d-none");
        this.startButton.classList.add("d-none")
        this.nextButton.classList.remove("d-none")

        this.applyQuestionVisibility();
    }

    protected next() {
        this.currentIndex += 1;

        if (this.currentIndex >= this.questions.length) {
            this.finish();
            return;
        }

        this.applyQuestionVisibility();
    }

    protected async restart() {
        this.resultsContainer.classList.add("d-none");
        this.overlay.classList.remove("d-none");

        const response = await fetch(this.quiz.dataset.fiveQuestionsRestart);
        const html = new DOMParser().parseFromString(await response.text(), "text/html")

        this.quiz.innerHTML = html.querySelector("[data-five-questions]").innerHTML;

        this.resolveElements();
        this.addListeners();
        this.start();
    }

    protected finish() {
        this.questionsContainer.classList.add("d-none");
        this.resultsContainer.classList.remove("d-none");
        this.restartButton.classList.remove("d-none");
        this.nextButton.classList.add("d-none");
        this.running = false;

        if (this.currentTime <= 0) {
            this.currentTime = 30;
            this.changeProgressBar(this.currentTime*100/30);
        }
    }

    protected applyQuestionVisibility() {
        this.questions.forEach((question) => {
            question.classList[question.dataset.fiveQuestionsQuestionItem === String(this.currentIndex) ? "remove" : "add"]("d-none");
        });
    }

    protected initAnimation() {
        setInterval(() => {
            if (this.running) {
                this.changeProgressBar(this.currentTime*100/30);
                this.currentTime -= 1/20

                if (this.currentTime <= 0) {
                    this.finish();
                }
            }
        }, 50);
    }

    protected changeProgressBar(percent: number) {
        const radius: number = (this.circleBar as any).r.baseVal.value;
        const circumference = radius * 2 * Math.PI;
        const offset = circumference - percent / 100 * circumference;

        this.circleBar.style.strokeDashoffset = String(offset);
        this.circleBar.style.strokeDasharray = `${circumference} ${circumference}`;

        this.timeText.innerText = String(Math.round(Math.ceil(this.currentTime)));
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll<HTMLElement>("[data-five-questions]").forEach((quiz: HTMLElement) => {
        new FiveQuestions(quiz);
    });
});
